document.addEventListener("DOMContentLoaded", function () {
  const items = document.querySelectorAll(".icon-list-with-image__item");
  const image = document.getElementById("dynamic-image");

  if (!items.length || !image) return;

  items.forEach((item) => {
    item.addEventListener("click", function () {
      const newImage = this.getAttribute("data-image");

      // Prevent error if no image
      if (!newImage) return;

      // Change image
      image.setAttribute("src", newImage);
      image.removeAttribute("srcset");

      // Active class handling
      items.forEach((i) => i.classList.remove("active"));
      this.classList.add("active");
    });
  });
});